if (!customElements.get('predictive-search')) {  
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
      this.isInit = false;
      this.searchInput = null;
      this.emptyResults = false;
      this.indexPrefix = this.dataset.prefix;
      this.headerIndex = `${this.indexPrefix}products_header_search${getSuffix()}`;
      this.querySuggestions = `${this.indexPrefix}products_query_suggestions${getSuffix()}`;
      this.queryCollections = `shopify_collections`;

      this.searchDebounceTimer = null;
      this.debounceDelay = 350; // ms
    }

    connectedCallback() {
      if (this.isInit) return;     
        
      if (window.algoliaIsLoaded) {
        this.init();
        return;
      }       
      
      window.addEventListener('algolia:script-loaded', () => {
        this.init();
      });
    }
    
    init() {
      if (this.isInit) return;     
      this.isInit = true;
      this.addDelegatedClickListeners();
    }
    
    addDelegatedClickListeners() {
      document.addEventListener('keyup', (e) => {    
        if (this.isOpen && e.key === "Escape") {
          this.close();
          return;
        }

        // debounce search input
        if (this.isOpen && this.searchInput && e.target === this.searchInput) {
          clearTimeout(this.searchDebounceTimer);
          this.searchDebounceTimer = setTimeout(() => {
            this.fetchSearchResults(this.searchInput.value);
          }, this.debounceDelay);
        }
      });
      
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-search-toggle="close"]')) {
          this.close();
          return;
        }

        if (e.target.closest('predictive-search')) return;
        
        if (e.target.closest('[data-search-toggle="open"]')) {
          this.searchInput = e.target.closest('[data-search-toggle="open"]');
          this.open();
          if (!this.emptyResults) {
            this.algoliaClient = window.algoliasearch('B8RIKEI9OC', '307ccfad891594b0e4b982aa6a862676');
            this.algoliaClient.initIndex(this.headerIndex);
            this.fetchSearchResults('');
            this.emptyResults = true;
          }
          return;
        }
        
        this.close();
      });
    }
    
    
    open() {
      if(this.isOpen) return
      this.isOpen = true;
      this.classList.remove('hidden');
      document.body.classList.add('scroll-lock', 'overlay-search');
      document.querySelector('[data-main-nav]')?.classList.add('overlay', 'blur');
      document.querySelector('site-header')?.closeAllMenus();
      
      const searchWrapper = this.querySelector('[data-search-wrapper]');
      searchWrapper.style.top = `${Math.ceil(this.searchInput.getBoundingClientRect()?.bottom)}px`;
      document.querySelector('[data-mobile-overlay]')?.classList.add('open-on-mobile');

      setTimeout(() => {
        this.classList.add('active');
        if (window.matchMedia('(max-width: 768px)').matches) {
          document.querySelector('input[name="q"]')?.focus().setSelectionRange(0, 999);
        }
      }, 100);

      const gorgias_container = document.querySelector('#gorgias-chat-container');
      if (gorgias_container) gorgias_container.style.zIndex = '-1';
      
      // document.querySelectorAll('.needsclick').forEach((needsclick_el) => {
      //   needsclick_el.style.zIndex = '-1';
      // });
    }

    close() {
      document.body.classList.remove('scroll-lock', 'overlay-search');
      this.isOpen = false;
      this.classList.remove('active');
      document.querySelector('[data-mobile-overlay]')?.classList.remove('open-on-mobile');
      document.querySelector('[data-main-nav]')?.classList.remove('blur');
      document.documentElement.classList.remove('cloud-search-mobile-open');

      setTimeout(() => {
        this.classList.add('hidden');
        document.querySelector('[data-main-nav]')?.classList.remove('overlay');
      }, 501);

      let submenu_open = false;
      const submenu_buttons = document.querySelectorAll('[data-action="open-submenu"]');

      submenu_buttons.forEach(button => {
        if (button.classList.contains('active')) submenu_open = true;
      });

      const gorgias_container = document.querySelector('#gorgias-chat-container');
      if (gorgias_container) gorgias_container.style.zIndex = submenu_open ? '-1' : '31';
      
      // document.querySelectorAll('.needsclick').forEach((needsclick_el) => {
      //   needsclick_el.style.zIndex = submenu_open ? '-1' : '31';
      // });
    }
    
    buildResultsPane(products, querySuggestions, query, collections, hits) {
      const searchWrapper = this.querySelector('[data-search-wrapper]');
      const popularSearches = this.querySelector('[data-popular-searches]');
      const collectionResults = this.querySelector('[data-collection-results]');
      const searchResults = this.querySelector('[data-search-results]');
      const searchCount = this.querySelector('[data-search-count]');
      const viewLabel = this.dataset.viewLabel;
      if (query) {
        searchWrapper.classList.add('has-results');
        searchCount.innerHTML = `(${hits})`;
      } else {
        searchWrapper.classList.remove('has-results');
        searchCount.innerHTML = '';
      }
      
     
      popularSearches.innerHTML = `
       ${ querySuggestions.length ?
          `<ul class="flex flex-col gap-4">
            ${querySuggestions.map((suggestion) => `
              <li class="leading-5">
                <a class="no-underline text-primaryDark hover:text-primaryBrand" href="/search?q=${suggestion.query}">
                  ${suggestion.query}
                </a>
              </li>
            `).join('')}
          </ul>` 
          : `<p class="text-gray-500">No suggestions found.</p>`}`;


        const filteredCollections = (collections || []).filter(
          (collection) => !collection.handle.includes('-colors')
        );

        if (filteredCollections.length) {
          searchWrapper.classList.remove('no-collection');
          collectionResults.innerHTML = `
            <ul class="flex flex-col gap-4">
              ${filteredCollections.map((collection) => `
                <li class="leading-5">
                  <a class="no-underline text-primaryDark hover:text-primaryBrand" href="/collections/${collection.handle}">
                    ${collection.title}
                  </a>
                </li>
              `).join('')}
            </ul>
          `;
        } else {
          searchWrapper.classList.add('no-collection');
          collectionResults.innerHTML = '';
        }

      
      searchResults.innerHTML =`
        ${query ? 
          `<div class="flex flex-col gap-5">
            <ul class="gap-2 grid grid-cols-2 md:grid-cols-4 max-w-[1400px]">
              ${products.slice(0, 4).map((product) => `
                <li class="bg-primaryLight rounded-md overflow-hidden aspect-[224/284] [&_product-mini-tile]:h-full [&_[data-product-url]]:justify-between [&_[data-product-url]]:h-full">
                    <intersection-loader 
                      data-url="/products/${product.handle}" 
                      data-section-id="product-mini-tile"
                      class="aspect-[224/284]"
                    ></intersection-loader> 
                  </li>
              `).join('')} 
            </ul>
            <a href="/search?q=${query}" class="max-md:hidden button-md button-primary block no-underline">${viewLabel}</a>
          </div>` : 
          this.querySelector('[data-trending-tiles]').innerHTML
        }
      `;
    }
    
    async fetchSearchResults(query) {
      await this.algoliaClient.multipleQueries([{
        indexName: this.headerIndex,
        clickAnalytics: true,
        params: {
          hitsPerPage: 4,
          page: 0,
          query, 
          filters: 'NOT tags:base_product AND NOT tags:hide_product'
        }
      },{
        indexName: this.querySuggestions,
        params: {
          query,
          hitsPerPage: 6,
        }
      },{
        indexName: this.queryCollections,
        params: {
          query,
          hitsPerPage: 7,
          filters: 'NOT meta.custom.predictive_search_hidden:true'
        }
      }], 1, false).then((res) => {
        console.log(res);
        window.dispatchEvent(new CustomEvent('algolia:setData', { 
          detail: { 
            queryID: res.results[0]?.queryID,
            index: this.currentIndex
          } 
        }));
        
        window.dispatchEvent(new CustomEvent('algolia:productsViewed', { 
          detail: { 
            products: res.results[0]?.hits
          } 
        }));
        
        if (!this.defaultProducts) this.defaultProducts = res?.results[0]?.hits;
        if (!res.results[0]?.hits.length) {
          this.buildResultsPane(this.defaultProducts, res.results[1]?.hits, res?.results[0]?.query, false );
          return;
        }
        if ((res.results[0]?.hits.length < 3) && this.defaultProducts) {
          this.buildResultsPane([...res.results[0]?.hits, ...this.defaultProducts], res.results[1]?.hits, res?.results[0]?.query, res.results[2]?.hits, res?.results[0]?.nbHits);
          return;
        }
        this.buildResultsPane(res?.results[0]?.hits, res.results[1]?.hits, res?.results[0]?.query,  res.results[2]?.hits, res?.results[0]?.nbHits );
      });
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}